import styled from '@emotion/styled';

export const Container = styled.div<{ mode: string }>`
  display: flex;
  justify-content: space-between;
  grid-template-columns: 1fr 32px;
  min-width: 232px;
  width: 100%;
  height: 40px;
  min-height: 40px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-radius: 6px;
  background: ${({ theme, mode }) => (mode === 'dark' ? '#2c2c2c' : theme.colors.neutral[150])};
  padding: 0 4px 0 8px;
`;

export const GroupBox = styled.div`
  display: flex;
  gap: 8px;
  flex: 1;
`;

export const IconButtonBox = styled.button`
  display: flex;
  padding: 6px;
  align-items: center;
  border-radius: 6px;
  background: transparent;
  cursor: pointer;

  /* &:hover {
        background: rgba(153, 153, 153, 0.05);
    } */
`;

export const SearchInput = styled.input<{ isDark: boolean }>`
  background: transparent;
  outline: none;
  width: 100%;
  border: none;
  color: ${({ theme, isDark }) => (isDark ? theme.colors.neutral[300] : theme.colors.neutral[700])};
  font-size: 14px;
  line-height: 18px;

  &::placeholder {
    color: ${({ theme, isDark }) => (isDark ? 'var(--sendbird-dark-ondark-02)' : theme.colors.neutral[350])};
  }
  &:-webkit-autofill {
    box-shadow: 0 0 0 30px white inset !important;
  }
  &:-webkit-autofill:hover {
    box-shadow: 0 0 0 30px white inset !important;
  }
  &:-webkit-autofill:focus {
    box-shadow: 0 0 0 30px white inset !important;
  }
  &:-webkit-autofill:active {
    box-shadow: 0 0 0 30px white inset !important;
  }

  &[type='password']::-ms-reveal,
  &[type='password']::-ms-clear {
    display: none;
  }
`;
